import React from "react";

interface Props {
    label?: string;
    value?: number;
    onChange: (value?: number) => void;
}

export function NumberInput(props: Props) {
    return (
        <input
            type="number"
            value={props.value ?? ""}
            onChange={e => {
                const value = parseInt(e.target.value);
                props.onChange(isNaN(value) ? undefined : value);
            }}
            style={{width: 100, height: 32, boxSizing: "border-box"}}
        />
    );
}
